export const WebhookListing = {
    list: function() {
        // get the page length when first load
        var initWindowHeight = jQuery(window).height();
        var initItemsPerPage = getPageLength(initWindowHeight);

        var table = jQuery('table.webhooks').DataTable({
            data: JSON.parse(jQuery('#webhooks-data').html()),
            info: false,
            lengthChange: false,
            language: {
                searchPlaceholder: I18n.t('search')
            },
            pageLength: initItemsPerPage, 
            autoWidth: false,
            initComplete: function () {
                DataTablesHelper.setAutoComplete(jQuery('table.webhooks'));
            },
            columnDefs: [
                {
                    orderable: false,
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#webhooks-actions-template').html().
                                replace(/__id__/g, data.id);
                        }
                        return '';
                    },
                    targets: [3]
                }
            ],
            footerCallback: function () {
                DataTablesHelper.togglePagination(this);
            }
        });

        table.on('click', 'a.delete-variable', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                jQuery.post(a.attr('href'), function() {
                    Turbo.visit(window.location.href);
                });
                a.hide();
            }
            return false;
        });
        var resizeId;
        // get the length after user stop resizing for 500ms
        jQuery(window).resize(function(){
            clearTimeout(resizeId);
            resizeId = setTimeout(resizeList, 500);
        })
        function resizeList(){
            var windowHeight = jQuery(window).height();
            var itemsPerPage = getPageLength(windowHeight);
            if (itemsPerPage!=table.page.len()){
                table.page.len(parseInt(itemsPerPage)).draw();
            }
        }
        function getPageLength(height) {
            switch(true){
                case height>1100:
                    return 20;
                case height>800:
                    return 15;
                case height>600:
                    return 10;
                default:
                    return 5;
            }
        }
    },

    _form: function() {
        jQuery('.smartme-toggle').smartmeToggle();
        $('.select2').select2();
        jQuery('#new-header').on('click', function(e){
            e.preventDefault();
            jQuery('#header-table').append(jQuery('#header-row-template').html().replace(/__idx__/g, jQuery('.header-row').length));
        });

        jQuery('#header-table').on('click', '.delete-header', function(e){
            e.preventDefault();
            jQuery(this).closest('.row').remove();
        });

        jQuery('#variable_purpose').on('change', function(e){
            const newOption = e.target.value;
            jQuery('#datagrids-selection').addClass('hidden');
            jQuery('#workflows-selection').addClass('hidden');

            if (JSON.parse(jQuery('#variable_purpose').attr('datagrid-methods')).includes(newOption)){
                jQuery('#datagrids-selection').removeClass('hidden');
            } else if (JSON.parse(jQuery('#variable_purpose').attr('workflow-methods')).includes(newOption)) {
                jQuery('#workflows-selection').removeClass('hidden');
            }
        })
        jQuery('#variable_purpose')[0].dispatchEvent(new Event('change'));

    },

    
}
